export default function getEchartOptionDetaliPageConRoom1(xAxis_data, series_data, line_color) {
	let option = {
		animation: false,
		grid: {
			// 让图表占满容器
			top: '20px',
			left: '0px',
			right: '0px',
			bottom: '20px',
		},
		xAxis: {
			data: xAxis_data,
			type: 'category', // 还有其他的type，可以去官网喵两眼哦
			name: '', // x轴名称
			// x轴名称样式
			nameTextStyle: {
				fontWeight: 600,
				fontSize: 18,
			},
			width: 1,
			show: false,
			//隐藏y轴轴线
			axisLine: {
				show: false,
			},
		},
		yAxis: {
			type: 'value',
			show: false,
			//隐藏y轴轴线
			axisLine: {
				show: false,
			},
			nameTextStyle: {
				fontWeight: 600,
				fontSize: 18,
			},
			min: -6,
			max: 6
		},
		series: [
			{
				data: series_data,
				// data:newYdata,
				type: 'line',
				smooth: true,
				symbol: 'none',
				showSymbol: false,
				hoverAnimation: false,
				silent: true,
				lineStyle: {
					color: line_color,
				},
			},
		],
	};
	return option;
}